import varAxios from "../../../Comman/axios";
import { updateHeartRunnerUrl,UpdateHeartRunnerStatusUrl,updateHeartRunnerPasswordUrl,heartRunnerInfoUrl } 
        from "../../../Comman/apiEndPoints"



export const UPDATE_PROFILE_SETTINGS_REQUEST = "(update) UPDATE PROFILE SETTINGS  REQUEST";
export const UPDATE_PROFILE_SETTINGS_SUCCESS = "(update) UPDATE PROFILE SETTINGS  SUCCESS";
export const UPDATE_PROFILE_SETTINGS_ERROR = "(update) UPDATE PROFILE SETTINGS  ERROR";

export const UPDATE_PASSWORD_SETTINGS_REQUEST = "(update) UPDATE PASSWORD SETTINGS  REQUEST";
export const UPDATE_PASSWORD_SETTINGS_SUCCESS = "(update) UPDATE PASSWORD SETTINGS  SUCCESS";
export const UPDATE_PASSWORD_SETTINGS_ERROR = "(update) UPDATE PASSWORD SETTINGS  ERROR";

export const FETCH_PROFILE_SETTINGS_DETAILS_REQUEST = "(fetch) FETCH PROFILE SETTINGS DETAILS REQUEST";
export const FETCH_PROFILE_SETTINGS_DETAILS_SUCCESS = "(fetch) FETCH PROFILE SETTINGS DETAILS SUCCESS";
export const FETCH_PROFILE_SETTINGS_DETAILS_ERROR = "(fetch) FETCH PROFILE SETTINGS DETAILS ERROR";


var statusCode=""
export function fetchProfileSettingsDetail(UserId, dispatch) {
    let data = {
        //AdminId: AdminId
        UserId: UserId
    }

    return (dispatch) => {
        dispatch(fetchProfileSettingsDetailRequest(true));

        return varAxios.post(heartRunnerInfoUrl, data,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
               
                dispatch(
                    fetchProfileSettingsDetailSuccess(false, response.data)
                );
            })
            .catch((error) => {
                // if(error.response.data.statusCode==401){
                    
                //     dispatch(
                //         fetchProfileSettingsDetail(UserId, dispatch)
                //     );
                // }
            })
    }
}

export function fetchProfileSettingsDetailRequest(isLoading) {
    return {
        type: FETCH_PROFILE_SETTINGS_DETAILS_REQUEST,
        isLoading
    }
}

export function fetchProfileSettingsDetailSuccess(isLoading, heartRunnerProfileInfo) {
    
    return {
        type: FETCH_PROFILE_SETTINGS_DETAILS_SUCCESS,
        isLoading,
        heartRunnerProfileInfo
    }
}

export function updateProfileSettings(formData, dispatch) {
    console.log(formData.entries())
    for(var pair of formData.entries()) {

        console.log(pair[0]+ ', '+ pair[1]); 
     }
       
    return (dispatch) => {
        dispatch(updateProfileSettingsRequest(true,statusCode));

        return varAxios.post(updateHeartRunnerUrl, formData,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
                dispatch(
                    updateProfileSettingsSuccess(false,
                     response.data.heartRunnerUserDetail,   
                     response.data.errorMessage,
                     response.data.errorCode,
                     response.data.statusCode)
                );
            })
            .catch((error) => {
                if(error.response.data.statusCode==401){
                    
                    dispatch(
                        updateProfileSettings(formData, dispatch)
                    );
                }
            })
    }
}


export function updateProfileSettingsRequest(isLoading) {
    return {
        type: UPDATE_PROFILE_SETTINGS_REQUEST,
        isLoading,
        statusCode
    }
}

export function updateProfileSettingsSuccess(isLoading, heartRunnerUserDetail,errorMessage , errorNumber ,  statusCode  ) {
   
    return {
        type: UPDATE_PROFILE_SETTINGS_SUCCESS,
        isLoading, 
        heartRunnerUserDetail,
        errorMessage ,
        errorNumber ,
        statusCode   
    }
}
export function updatePasswordSettings(formData, dispatch) {
   
    
    return (dispatch) => {
        dispatch(updatePasswordSettingsRequest(true));

        return varAxios.post(updateHeartRunnerPasswordUrl, formData,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
                console.log(response)
                dispatch(
                    updatePasswordSettingsSuccess(false,
                     response.data.errorMessage,
                     response.data.errorCode,
                     response.data.statusCode
                    )
                );
            })
            .catch((error) => {
                if(error.response.data.statusCode==401){
                    
                    dispatch(
                        updatePasswordSettings(formData, dispatch)
                    );
                }
            })
    }
}


export function updatePasswordSettingsRequest(isLoading) {
    return {
        type: UPDATE_PASSWORD_SETTINGS_REQUEST,
        isLoading
    }
}

export function updatePasswordSettingsSuccess(isLoading, errorMessage , errorNumber ,  statusCode  ) {
    return {
        type: UPDATE_PASSWORD_SETTINGS_SUCCESS,
        isLoading,
        errorMessage ,
        errorNumber ,
        statusCode   
    }
}

export function updateStatusSettings(formData, dispatch) {
   
    
    return (dispatch) => {
        dispatch(updateProfileSettingsRequest(true,statusCode));

        return varAxios.post(UpdateHeartRunnerStatusUrl, formData,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
                dispatch(
                    updateProfileSettingsSuccess(false,
                     response.data.heartRunnerUserDetail,   
                     response.data.errorMessage,
                     response.data.errorCode,
                     response.data.statusCode)
                );
            })
            .catch((error) => {
                if(error.response.data.statusCode==401){
                    
                    dispatch(
                        updateProfileSettings(formData, dispatch)
                    );
                }
            })
    }
}
